import { createSelector } from "reselect";

import { getTripsOperators } from "./state-accessors";

export const getTripsOperatorsProfileNames = createSelector(
  [getTripsOperators],
  trips_operators =>
    Object.values(trips_operators).reduce(
      (map, trip_operator) =>
        trip_operator.profile_id
          ? map.set(trip_operator.profile_id, trip_operator.name)
          : map,
      new Map<number, string>()
    )
);
